<button
  *mrIfHasPermission="Permission.CreateHelpAssistTicket"
  (click)="openTicketModal()"
  [disabled]="isModalOpen"
>
  <mr-icon name="help" aria-hidden="true"></mr-icon>Help
</button>
